"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiGameInfoBar = void 0;
var _pixi = require("pixi.js");
var _core = require("@dragon/core");
var _pixiGame = require("@dragon/pixi-game");
var _PixiWinCounter = require("./PixiWinCounter");
var _gsap = _interopRequireDefault(require("gsap"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PixiGameInfoBar = exports.PixiGameInfoBar = /*#__PURE__*/function (_PixiGameComponent) {
  function PixiGameInfoBar(componentName, _textStyle, bmFontStyle) {
    var _this;
    var backgroundSprite = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "info_bg.png";
    _classCallCheck(this, PixiGameInfoBar);
    _this = _callSuper(this, PixiGameInfoBar, [componentName]);
    _defineProperty(_this, "_instantiated", void 0);
    _defineProperty(_this, "_background", void 0);
    _defineProperty(_this, "counter", void 0);
    _defineProperty(_this, "infoText", void 0);
    _defineProperty(_this, "idleContainer", void 0);
    _defineProperty(_this, "specialMessageActive", void 0);
    _defineProperty(_this, "idleSprites", void 0);
    _defineProperty(_this, "lastStatus", void 0);
    _defineProperty(_this, "locale", void 0);
    _defineProperty(_this, "winXvalue", void 0);
    _defineProperty(_this, "currentIdleSprite", 0);
    _defineProperty(_this, "preSpecialMessage", void 0);
    _defineProperty(_this, "nextIdleSprite", function () {
      _this.idleSprites[_this.currentIdleSprite % _this.idleSprites.length].visible = false;
      _this.currentIdleSprite++;
      _this.idleSprites[_this.currentIdleSprite % _this.idleSprites.length].visible = true;
      _this.idleContainer.setAnchor(0.5);
      _this.idleContainer.x = _this._background.width / 2;
      _this.idleContainer.y = _this._background.height / 2 + 8;
    });
    _defineProperty(_this, "generateIdleSprite", function (translationKey, textStyle, textureName) {
      var textY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var container = new _pixiGame.CustomPixiContainer();
      var string = _core.CORE.translate(translationKey);
      if (textureName) {
        var t = string.split('{0}');
        var p1, p2;
        p1 = new _pixi.Text(t[0], textStyle);
        p1.anchor.set(0, 0.5);
        var s1 = new _pixi.Sprite(_pixi.Texture.from(textureName));
        s1.height = p1.height;
        s1.scale.set(s1.scale.y);
        container.addChild(s1);
        p1.y = s1.height / 2;
        p1.resolution = 2;
        container.addChild(p1);
        s1.x = p1.width + 6;
        p2 = new _pixi.Text(t[1], textStyle);
        p2.anchor.set(0, 0.5);
        p2.x = s1.x + s1.width + 6;
        p2.resolution = 2;
        p1.y = s1.height / 2;
        p2.y = s1.height / 2;
        container.addChild(p2);
      } else {
        var _p = new _pixi.Text(string, textStyle);
        container.addChild(_p);
      }
      var renderTexture = _pixi.RenderTexture.create({
        width: container.width - 20,
        height: container.height,
        resolution: 2
      });
      _this.application.renderer.render(container, {
        renderTexture: renderTexture
      });
      var s = new _pixi.Sprite(renderTexture);
      s.visible = false;
      return s;
    });
    _defineProperty(_this, "specialMessage", function (msg) {
      _this.specialMessageActive = true;
      _this.preSpecialMessage = _this.infoText.text;
      _this.infoText.text = msg;
      _this.infoText.x = _this._background.width / 2;
      _gsap["default"].killTweensOf(_this.infoText);
      _this.infoText.alpha = 1;
      _gsap["default"].to(_this.infoText, {
        alpha: 0.4,
        repeat: -1,
        yoyo: true,
        duration: 0.4
      });
      _this.counter.hide();
    });
    _defineProperty(_this, "specialMessageOff", function () {
      _gsap["default"].killTweensOf(_this.infoText);
      _this.specialMessageActive = false;

      // we always go back to "wun here since counter will show"
      _this.infoText.text = _core.CORE.translate('statusText' + 4);
      _this.infoText.x = _this.winXvalue;
      _this.counter.show();
    });
    _defineProperty(_this, "handleInfoState", function (s, coinsWon) {
      if (s === undefined) return;
      _this.idleContainer.visible = false;
      _gsap["default"].killTweensOf(_this.infoText);
      _gsap["default"].killTweensOf(_this.idleContainer);
      _this.infoText.alpha = 1;
      switch (s) {
        case _core.StatusTextState.TotalWin:
        case _core.StatusTextState.Win:
          {
            if (_this.specialMessageActive) {
              _this.counter.set(coinsWon);
              break;
            }
            if (coinsWon > 0) {
              _this.infoText.x = _this.winXvalue;
              _this.infoText.text = _core.CORE.translate('statusText' + s);
              _this.counter.setCounter(coinsWon);
            } else if (coinsWon == 0) {
              _this.counter.resetPrevious();
            }
            break;
          }
        case _core.StatusTextState.Blitz:
        case _core.StatusTextState.Idle:
          {
            _this.counter.hide();
            _this.counter.reset();
            _this.infoText.alpha = 0;
            _this.idleContainer.alpha = 1;
            _this.idleContainer.visible = true;
            _this.idleSprites[_this.currentIdleSprite % _this.idleSprites.length].visible = true;
            _this.idleContainer.setAnchor(0.5);
            _this.idleContainer.x = _this._background.width / 2;
            _this.idleContainer.y = _this._background.height / 2 + 8;
            var counter = 0;
            _gsap["default"].to(_this.idleContainer, {
              duration: 1,
              alpha: 0.6,
              repeat: -1,
              yoyo: true,
              onRepeat: function onRepeat() {
                counter++;
                if (counter == 7) {
                  _this.nextIdleSprite();
                  counter = 0;
                }
              }
            });
            break;
          }
        default:
          {
            _this.infoText.x = _this._background.width / 2;
            _this.counter.hide();
            _this.counter.reset();
            _this.infoText.text = _core.CORE.translate('statusText' + s);
            break;
          }
      }
      _this.lastStatus = s;
    });
    _defineProperty(_this, "hide", function (instant) {
      _gsap["default"].killTweensOf(_this);
      if (instant) _this.alpha = 0;
      _gsap["default"].to(_this, {
        alpha: 0,
        duration: 0.5
      });
    });
    _defineProperty(_this, "show", function (instant) {
      _gsap["default"].killTweensOf(_this);
      if (instant) _this.alpha = 1;
      if (_this.alpha != 1) {
        _gsap["default"].to(_this, {
          alpha: 1,
          duration: 0.5
        });
      }
    });
    _this.idleSprites = [];
    _this.locale = _core.CORE.getState().config.locale;
    _this.winXvalue = 60;
    _this._background = new _pixi.Sprite(_pixi.Texture.from(backgroundSprite));
    _this.addChild(_this._background);
    _this.infoText = new _pixi.Text("", _textStyle);
    _this.infoText.resolution = 2;
    _this.infoText.anchor.set(0.5, 0.5);
    _this.addChild(_this.infoText);

    //#region play button thinige
    _this.idleContainer = new _pixiGame.CustomPixiContainer();
    _this.idleContainer.visible = false;
    _this.addChild(_this.idleContainer);
    //#endregion
    //#region scatter symbol thingie

    //#endregion
    _this.counter = new _PixiWinCounter.PixiWinCounter("GameInfoBarWinCounter", bmFontStyle);
    _core.CORE.subscribe('ui.statusTextState', _this.handleInfoState);
    _core.CORE.subscribe('game.winCounter', function (a) {
      return _this.handleInfoState(_core.StatusTextState.Win, a);
    });
    _this.counter.x = _this.width / 2;
    //  this.counter.y = 16
    _this.addChild(_this.counter);
    _this._instantiated = true;
    return _this;
  }
  _inherits(PixiGameInfoBar, _PixiGameComponent);
  return _createClass(PixiGameInfoBar, [{
    key: "onResize",
    value: function onResize(s) {
      if (!this._instantiated) return;
      this.infoText.x = this._background.width / 2;
      this.infoText.y = this._background.height / 2;
      if (this.lastStatus === _core.StatusTextState.TotalWin || this.lastStatus === _core.StatusTextState.Win) {
        this.infoText.x = this.winXvalue;
      }
      this.idleContainer.setAnchor(0.5);
      this.idleContainer.x = this._background.width / 2;
      this.idleContainer.y = this._background.height / 2 + 8;
    }
  }]);
}(_pixiGame.PixiGameComponent);
//# sourceMappingURL=PixiGameInfoBar.js.map